var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"cxm-CardContent",class:{ 'cxm-CardContent-Shadow': _vm.shadow, 'cxm-CardContent-CursorPointer': _vm.showCursorPointer }},_vm.handleClick ? { click: _vm.handleClick } : {}),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }